import { useState } from "react";
import { FaCrown, FaMedal, FaAward, FaSpinner, FaCheckCircle } from "react-icons/fa";

const PartnershipForm = ({ onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsSubmitted(false);

    try {
      await onSubmit(e); // assumes onSubmit is async
      setIsSubmitted(true);
      e.target.reset();
    } catch (err) {
      console.error("Submission failed", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const categories = [
    { label: "Gold", value: "Gold", desc: "100,000XAF / 150 USD / 150 EUR", color: "border-yellow-400 bg-yellow-100 text-yellow-900", Icon: FaCrown },
    { label: "Silver", value: "Silver", desc: "50,000XAF / 100 USD / 100 EUR", color: "border-gray-400 bg-gray-100 text-gray-800", Icon: FaMedal },
    { label: "Bronze", value: "Bronze", desc: "25,000XAF / 50 USD / 50 EUR", color: "border-amber-500 bg-amber-100 text-amber-900", Icon: FaAward },
  ];

  return (
    <section className="mt-2 bg-gray-800 backdrop-blur-md rounded-md px-5 shadow-md text-white max-w-xl mx-auto" aria-label="Partnership Form">
      <h2 className="text-2xl font-bold text-yellow-300 border-b border-yellow-300 pb-2 mb-4">
        Become a Covenant Partner
      </h2>

      <form onSubmit={handleSubmit} className="space-y-3" autoComplete="on">
        <input type="hidden" name="formType" value="covenant-partner" />

        <div>
          <label htmlFor="name">Full Name</label>
          <input id="name" name="name" type="text" autoComplete="name" required className="w-full px-3 py-2 rounded bg-white/20 text-white border border-yellow-300 focus:outline-none" />
        </div>

        <div>
          <label htmlFor="country">Country</label>
          <input id="country" name="country" type="text" autoComplete="country-name" required className="w-full px-3 py-2 rounded bg-white/20 text-white border border-yellow-300 focus:outline-none" />
        </div>

        <div>
          <label htmlFor="address">Address</label>
          <input id="address" name="address" type="text" autoComplete="street-address" required className="w-full px-3 py-2 rounded bg-white/20 text-white border border-yellow-300 focus:outline-none" />
        </div>

        <div>
          <label htmlFor="phone">Phone Number</label>
          <input id="phone" name="phone" type="tel" autoComplete="tel" required className="w-full px-3 py-2 rounded bg-white/20 text-white border border-yellow-300 focus:outline-none" />
        </div>

        <div>
          <label htmlFor="email">Email</label>
          <input id="email" name="email" type="email" autoComplete="email" required className="w-full px-3 py-2 rounded bg-white/20 text-white border border-yellow-300 focus:outline-none" />
        </div>

        <div>
          <label className="block font-semibold text-yellow-300 mb-1">Partnership Category</label>
          <div className="grid gap-2 sm:grid-cols-1">
            {categories.map(({ label, value, desc, color, Icon }) => (
              <label key={value} className={`flex items-center space-x-3 p-3 rounded-lg border ${color} cursor-pointer transition hover:shadow-md hover:scale-[1.01]`}>
                <input type="radio" name="category" value={value} required autoComplete="off" className="form-radio h-5 w-5 text-yellow-400 focus:ring-yellow-300" />
                <Icon className="text-2xl" />
                <div>
                  <div className="font-bold text-base">{label}</div>
                  <div className="text-xs font-bold">{desc}</div>
                </div>
              </label>
            ))}
          </div>
        </div>

        <div>
          <label htmlFor="comment">Comments</label>
          <textarea id="comment" name="comment" rows="3" autoComplete="off" className="w-full px-3 py-2 rounded bg-white/20 text-white border border-yellow-300 focus:outline-none"></textarea>
        </div>

        <div className="text-center py-3">
          <button type="submit" className="m-2 bg-blue-700 hover:bg-yellow-700 text-white font-medium py-2 px-10 rounded-md flex items-center justify-center gap-2 transition" disabled={isSubmitting}>
            {isSubmitting ? <><FaSpinner className="animate-spin" /> Sending...</> : "Send"}
          </button>

          {isSubmitted && (
            <div className="mt-2 text-green-400 flex items-center justify-center gap-2">
              <FaCheckCircle /> Message sent successfully!
            </div>
          )}
        </div>
      </form>
    </section>
  );
};

export default PartnershipForm;
